import { defineCopy } from "@tami/core/intl";

import { CAMPANHAS_SCRIPT_COPY_EN_US } from "./en-us/campanhas-script.copy";
import { CAMPANHAS_SCRIPT_COPY_ES_ES } from "./es-es/campanhas-script.copy";

export const CAMPANHAS_SCRIPT_COPY_PT_BR = {
  campIntro: {
    narrative:
      "Central de Campanhas: todas as parcerias com marcas organizadas do primeiro contato ao encerramento.",
  },
  campGrid: {
    narrative:
      "Salve briefing, contatos, valores e entregáveis num único card — e acompanhe cada estágio da negociação.",
    callout:
      "Briefing, contatos e valores de cada marca — do 'Conversando' até 'Encerrada'.",
  },
  campModalOpen: {
    narrative:
      "Cadastre uma campanha nova em segundos — nome, marca, prazo e contexto num fluxo guiado.",
    callout:
      "Modal de campanha: organize parcerias sem sair da Central de Campanhas.",
  },
  campModalTitle: {
    narrative:
      "Comece pelo nome da campanha — coleção, lançamento ou collab, tudo fica fácil de achar depois.",
    callout:
      "Dê um nome claro à campanha — o ponto de partida de toda negociação.",
  },
  campModalBrand: {
    narrative:
      "Vincule a marca parceira e mantenha o histórico de cada relacionamento comercial.",
    callout:
      "Registre qual marca está por trás da campanha — essencial para relatórios e finanças.",
  },
  campModalDeadline: {
    narrative:
      "Defina prazo de encerramento e anote o contexto — briefing e regras num só lugar.",
    callout:
      "Prazo e contexto da campanha — zero surpresa na hora de entregar.",
  },
  campModalDeliverables: {
    narrative:
      "Na aba Entregáveis, registre cada peça da campanha: rede, formato, prazo e valor.",
    callout:
      "Cada entregável com plataforma, formato e prazo — escopo claro desde o início.",
  },
  campModalDeliverablesList: {
    narrative:
      "Todos os entregáveis numa tabela — status, prazos e valores visíveis de uma vez.",
    callout:
      "Resumo do escopo por rede — Reels, vídeos e stories organizados por plataforma.",
  },
  campModalPayment: {
    narrative:
      "Na aba Pagamento, distribua o valor entre entregáveis e defina como vai receber.",
    callout:
      "Valor por entregável e forma de pagamento — negocie com números na mesa.",
  },
  campModalPaymentTotal: {
    narrative:
      "Total da campanha calculado automaticamente — à vista ou parcelado, você escolhe.",
    callout:
      "Total consolidado da campanha — entregas + extras, tudo transparente.",
  },
  campOutro: {
    narrative:
      "Nunca mais perca o fio de uma negociação por falta de organização.",
  },
} as const;

export const CAMPANHAS_SCRIPT_COPY = defineCopy(CAMPANHAS_SCRIPT_COPY_PT_BR, {
  "en-US": CAMPANHAS_SCRIPT_COPY_EN_US,
  "es-ES": CAMPANHAS_SCRIPT_COPY_ES_ES,
});
